import type { ReactNode } from 'react'
import { cn } from '@/lib/utils/helpers'

/**
 * Configuration-module (and other admin) list pages: shared chrome around sortable data tables.
 * Matches Policy / Stock Registry / Whats New — `rounded-xl` card, slate header row, divided body.
 */
export const LISTING_DATA_TABLE_CARD_CLASS =
  'min-w-0 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm'

export const LISTING_DATA_TABLE_SCROLL_CLASS = 'min-w-0 overflow-x-auto'

export const LISTING_DATA_TABLE_CLASS = 'min-w-full text-sm'

export const LISTING_DATA_TABLE_HEAD_CLASS = 'bg-[#f8fafc] border-b-2 border-[#e2e8f0] text-[#475569] [&_th]:text-xs [&_th]:font-semibold [&_th]:uppercase [&_th]:tracking-[0.03em]'

export const LISTING_DATA_TABLE_BODY_CLASS = 'divide-y divide-slate-100'

type DivProps = {
  children: ReactNode
  className?: string
  'data-testid'?: string
}

export function ListingDataTableCard({ children, className, 'data-testid': dataTestId }: DivProps) {
  return (
    <div data-testid={dataTestId} className={cn(LISTING_DATA_TABLE_CARD_CLASS, className)}>
      {children}
    </div>
  )
}

export function ListingDataTableScroll({ children, className, 'data-testid': dataTestId }: DivProps) {
  return (
    <div data-testid={dataTestId} className={cn(LISTING_DATA_TABLE_SCROLL_CLASS, className)}>
      {children}
    </div>
  )
}
